import { Row, Col } from 'antd';

const GridContratoIva = ({ budget, budget_iva, budget_not_iva, iva }) => {
    console.log("contrato***", budget, budget_iva, budget_not_iva, iva)
    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const budgetIva = budget * (budget_iva/100);
    const budgetIvaPlusIva = (iva/100) * budgetIva;
    const realBudgetIva = budgetIva + budgetIvaPlusIva;

    return (
        <>
            <Col xs={24} md={12}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <h4 className='title-custom'>CONTRATO CON IVA</h4>
                </Row>

                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Presupuesto con IVA:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {budget_not_iva === 100 ? "No aplica" : `$ ${numberFormat.format(budgetIva) || '0.00'}`}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600 }}>
                            IVA (con IVA):
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {budget_not_iva === 100 ? "No aplica" : `$ ${numberFormat.format(budgetIvaPlusIva) || '0.00'}`}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600 }}>
                            Monto 1 (con IVA):
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {budget_not_iva === 100 ? "No aplica" : `$ ${numberFormat.format(realBudgetIva) || '0.00'}`}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )

}

export default GridContratoIva;